/**
 * Shared Plantafel toolbar control sizes — match Settings `h-9` / `rounded-md`
 * (see `.cursor/rules/ui-form-controls.mdc`).
 */

export const PLANTAFEL_FILTER_TRIGGER_CLASS =
  'inline-flex h-9 items-center gap-1.5 rounded-md border-0 bg-transparent px-2.5 text-sm font-medium leading-none text-app-text-muted hover:bg-app-hover hover:text-app-text';

/** Icon-only ghost control (Einstellungen). */
export const PLANTAFEL_GHOST_ICON_TRIGGER_CLASS =
  'inline-flex h-9 w-9 items-center justify-center rounded-md border-0 bg-transparent text-app-text-subtle hover:bg-app-hover hover:text-app-text';

export const PLANTAFEL_BTN_OUTLINE_CLASS =
  'inline-flex h-9 items-center gap-1.5 rounded-md border border-app-border bg-app-surface px-3 text-sm font-medium text-app-text-muted hover:bg-app-hover disabled:cursor-not-allowed disabled:opacity-50';

export const PLANTAFEL_SEARCH_INPUT_CLASS =
  'h-9 w-full rounded-md border border-app-border bg-app-surface-muted pl-8 pr-8 text-sm text-app-text outline-none placeholder:text-app-text-subtle focus:border-pipedrive-blue focus:bg-app-surface focus:ring-2 focus:ring-pipedrive-blue/20 sm:w-[200px]';
